const items = [
  {
    img: "https://images.unsplash.com/photo-1668460627275-9ff46f3a0b7e?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzN8MHwxfHNlYXJjaHwxfHxub3J3YXklMjBwb3dlciUyMGdyaWQlMjB0d2lsaWdodHxlbnwwfHx8fDE3OTA4NTEwMTl8MA&ixlib=rb-4.1.0&q=85",
    alt: "Høyspentmaster mot morgenhimmel",
    tag: "Kraftnett & Master",
    title: "Nettleie- og overføringslinjer",
  },
  {
    img: "https://images.unsplash.com/photo-1658870901055-665c9621d7a9?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NjZ8MHwxfHNlYXJjaHwyfHxwb3dlciUyMHRyYW5zZm9ybWVyJTIwc3Vic3RhdGlvbnxlbnwwfHx8fDE3OTA4NTEwMjZ8MA&ixlib=rb-4.1.0&q=85",
    alt: "Transformatorstasjon og distribusjonsnett",
    tag: "Transformatorstasjon",
    title: "Lokal distribusjon til næringsliv",
  },
  {
    img: "https://images.unsplash.com/photo-1621264448270-9ef00e88a935?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1MDV8MHwxfHNlYXJjaHw0fHxmaW5hbmNlJTIwdHJhZGluZyUyMHNjcmVlbnxlbnwwfHx8fDE3OTA4NTEwMjZ8MA&ixlib=rb-4.1.0&q=85",
    alt: "Overvåking av kraftbørsene Nordpool og Nasdaq",
    tag: "Kraftbørs",
    title: "Nasdaq & Nordpool overvåking",
  },
  {
    img: "https://images.unsplash.com/photo-1646153114001-495dfb56506d?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NzV8MHwxfHNlYXJjaHwxfHxtb2Rlcm4lMjBpbGx1bWluYXRlZCUyMHdvcmtzcGFjZXxlbnwwfHx8fDE3OTA4NTEwMTl8MA&ixlib=rb-4.1.0&q=85",
    alt: "Moderne opplyst næringsbygg",
    tag: "Belysning & Forbruk",
    title: "Effektiv energi i hverdagen",
  },
];

const GallerySection = () => (
  <section id="galleri" className="py-24 bg-slate-900 text-white" data-testid="gallery-section">
    <div className="max-w-7xl mx-auto px-6">
      <div className="text-center max-w-2xl mx-auto mb-16">
        <span className="text-xs font-bold uppercase tracking-widest text-emerald-400">
          Strømmarkedet i bilder
        </span>
        <h2 className="font-serif-heading text-3xl sm:text-4xl font-bold mt-2">
          Energi og kraftnett for norsk næringsliv
        </h2>
        <p className="text-slate-400 mt-4 text-sm leading-relaxed">
          Nettleiemaster, transformatorstasjoner, kraftstasjoner og handel på
          Nordpool – slik sikrer vi forutsigbar strøm.
        </p>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
        {items.map((item, i) => (
          <div
            key={item.tag}
            className="aspect-[4/3] rounded-xl border border-white/10 relative overflow-hidden group"
            data-testid={`gallery-item-${i + 1}`}
          >
            <img
              src={item.img}
              alt={item.alt}
              className="absolute inset-0 w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
              loading="lazy"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/20 to-transparent" />
            <div className="absolute bottom-0 left-0 right-0 p-5">
              <span className="text-xs font-bold text-emerald-400 uppercase">{item.tag}</span>
              <p className="text-sm font-semibold text-white mt-1">{item.title}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  </section>
);

export default GallerySection;
